export default __webpack_public_path__ + "static/media/elevate-red-banner-2.4de700e0.jpg";